// 擒龙需求3.8
const rhsocket = window.rhsocket
let timer
class Socket {
  constructor() {
    this.appCode = null
    this._rhsocket = null
    this.isConnect = false // 是否连接
    this.isTopic = true // 是否订阅
    this.username = ''
    this.ext = {}
    this.intervalRhsockets = null // 发送心跳
  }
  async socketInit({username, appCode}, callBack) {
    this.username = username
    this.appCode = appCode
    if (this.isConnect || !username) return // 防止重复发起连接,没有username不注册
    let socketEnv = ['local', 'integration'].includes(process.env.VUE_APP_WEB) ? 'development' : 'production'
    this._rhsocket = new rhsocket({
      'env': socketEnv,
      username,
      appCode,
      channel: 'h5',
      debugger: true,
    })
    await this._rhsocket.init()
    this._rhsocket.on('open', () => {
      console.log('is connect...')
      this.isConnect = true
      this.isTopic = true
      this.intervalRhsockets = (userId) => {
        setInterval(() => this._rhsocket.send({
          type: 2,
          userId,
      }), 5000)
      }
    })
    this._rhsocket.on('close', () => {
      console.log('close-----关闭了...')
      this.isConnect = false
      this.isTopic = false
    })
    // 报错重新链接+订阅
    this._rhsocket.on('error', async function (event) {
      console.log('WebSocket error: ', event);
      this.isConnect = false
      this.isTopic = false
      console.log('error----this._rhsocket', this._rhsocket)
      console.log('error----this.username', this.username)
      console.log('error----this.ext', this.ext)
      await this.socketInit({username: this.username})
      setTimeout(() => {
        this.socketSend({ ...this.ext, type: 5 })
      }, 2000)
    })
    this._rhsocket.on('message', (data) => {
      console.log('ws获取message:', data)
      let info = {}
      try {
        info = JSON.parse(JSON.parse(data).message) || {}
      } catch (e) {
        console.log('info格式不符合要求')
        return
      }
      callBack(info)
    })
  }
  // type类型
  // 1 代表连接
  // 2 代表心跳
  // 3 代表登录
  // 4 代表退出登录
  // 5 代表订阅topic
  // 6 代表取消订阅topic
  // 7 代表离线
  socketSend(ext) {
    // 确认连接后才能获取_rhsocket对象
    if (timer) {
      clearInterval(timer)
    }
    if (!this.isConnect) {
      timer = setInterval(() => {
        this.socketSend(ext)
      }, 2000)
      return
    }
    this.intervalRhsockets(this._rhsocket.userId)
    this.ext = ext
    console.log('socket发送-----', ext)
    const { type, topic } = this.ext
    console.log(this.isConnect, 'isConnect')
    const config = (type === 5) ? {
      topic,
      username: this._rhsocket.username,
      userId: this._rhsocket.userId,
      appCode: this.appCode,
    } : {}
    console.log('socket发送配置-----', {
      type,
      ...config
    })
    this._rhsocket.send({
      type,
      ...config
    })
    type === 5 && (this.isTopic = true)
    type === 6 && (this.isTopic = false)
  }
} 
const rSocket = new Socket()

export {
  Socket,
  rSocket
}